import { buildClassesHook } from '../../../helpers/styles';

export const useClasses = buildClassesHook({
    autoGrid: {
        gridAutoColumns: 'max-content',
        gridAutoRows: 'max-content',
    },
});
